import { getFlagEnabled } from "./getFlagValue"

const COBRANDING_FLAG_KEY = "WA-9539-web-cobranding"

/**
 * Chooses between a legacy Rhumbix logo source and the cobranded logo source,
 * gated behind the web cobranding flag.
 *
 * Parameters:
 * legacySrc (string): The image source to use when the flag is off.
 * cobrandedSrc (string): The image source to use when the flag is on.
 *
 * Returns:
 * string: The image source to render.
 */
export const getLogoSrc = (legacySrc: string, cobrandedSrc: string): string => (getFlagEnabled(COBRANDING_FLAG_KEY) ? cobrandedSrc : legacySrc)

/**
 * Returns whether the web cobranding flag is on, so callers can apply
 * cobranded-only sizing classes without resizing the legacy logo.
 *
 * Returns:
 * boolean: True when the cobranding flag is enabled.
 */
export const isCobrandingEnabled = (): boolean => getFlagEnabled(COBRANDING_FLAG_KEY)
